import React, { useMemo } from 'react'
import { useAuth } from '../auth/AuthContext'
import MenuOverviewList from '../components/MenuOverviewList'
import { createMenuVisibilityContext } from '../lib/menu'
import { getApiErrorMessage } from '../lib/api'
import {
  useMenuFavoritesQuery,
  useMenuFavoriteToggle,
} from '../lib/menu/menuFavorites'
import { resolveFavoriteMenuItems } from '../lib/menu/menuFavoriteResolution'
import { collectOverviewSections } from '../lib/menu/menuOverviewSections'
import { useToast } from '../ui/ToastProvider'

export default function MenuOverviewPage() {
  const { user, hasAnyRole, hasAnyPermission, hasAnyCapability } = useAuth()
  const { show } = useToast()
  const favoritesQuery = useMenuFavoritesQuery({ enabled: Boolean(user) })
  const favoriteToggle = useMenuFavoriteToggle()

  const menuCtx = useMemo(
    () => createMenuVisibilityContext(user, { hasAnyRole, hasAnyPermission, hasAnyCapability }),
    [user, hasAnyRole, hasAnyPermission, hasAnyCapability],
  )

  const blocks = useMemo(() => collectOverviewSections(menuCtx), [menuCtx])
  const favoriteMenuIds = useMemo(
    () => new Set(resolveFavoriteMenuItems(favoritesQuery.data, blocks).map((item) => item.id)),
    [favoritesQuery.data, blocks],
  )

  async function handleToggleFavorite(item, favorite) {
    try {
      await favoriteToggle.mutateAsync({ item, favorite })
      show(favorite ? '즐겨찾기에서 해제했습니다.' : '즐겨찾기에 추가했습니다.', 'success')
    } catch (error) {
      show(getApiErrorMessage(error, '즐겨찾기를 변경하지 못했습니다.'), 'error')
    }
  }

  return (
    <section className="space-y-6">
      <h1 className="text-3xl font-bold text-slate-900">메뉴 전체보기</h1>
      <MenuOverviewList
        blocks={blocks}
        favoriteMenuIds={favoriteMenuIds}
        pendingMenuId={favoriteToggle.isPending ? favoriteToggle.variables?.item?.id : null}
        onToggleFavorite={handleToggleFavorite}
      />
    </section>
  )
}